var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"listen-audio-view"}},[_c('l-aud')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }